export default __webpack_public_path__ + "static/media/avatarC2.7beef9db.png";